import { render, staticRenderFns } from "./orderiklanfrm.vue?vue&type=template&id=546821fd&scoped=true"
import script from "./orderiklanfrm.vue?vue&type=script&lang=js"
export * from "./orderiklanfrm.vue?vue&type=script&lang=js"
import style0 from "./orderiklanfrm.vue?vue&type=style&index=0&id=546821fd&prod&scoped=true&lang=css"
import style1 from "./orderiklanfrm.vue?vue&type=style&index=1&id=546821fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546821fd",
  null
  
)

export default component.exports